import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { updateFields } from 'apps/auth/actions/formAction';
import { updatePageMessages } from 'apps/auth/actions/messageAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { RECIPIENT_TYPE_SELF } from 'apps/auth/constants/Constants';
import {
    KEEP_AMOUNT,
    TO_NAME,
    TO_NAME_F,
    TO_RECIPIENT,
    TO_RECIPIENT_CATEGORY_TYPE,
    TO_RECIPIENT_OTHER,
    TO_RECIPIENT_SELF,
} from 'apps/auth/constants/fieldsName';
import { SEND_FORM_NAME } from 'apps/auth/constants/formName';
import { apiFetchData, changeBrowserUrlWithOutReload } from 'apps/auth/helpers/api';
import { getRepeatQueryParams } from 'apps/auth/helpers/utils';
import { useExtra, useForm, usePageMessages } from 'apps/auth/hooks/selectors';

const ChangeRecipientTypeToMyself = ({ popupRef = null, ...props }) => {
    const { fields } = useForm(SEND_FORM_NAME);
    const extra = useExtra();
    const { repeatId, recipientId } = getRepeatQueryParams();

    const fieldMappings = {
        [TO_NAME]: extra.profile.userName,
        [TO_NAME_F]: extra.profile.userLastName,
        [TO_RECIPIENT]: extra.profile.fullName,
    };

    const fieldsForMyself = [TO_NAME, TO_NAME_F, TO_RECIPIENT];

    const getNewFieldsForMyself = () => {
        let updatedFields = {};
        fieldsForMyself.forEach((name) => {
            let field = fields[name];
            if (field) {
                field.value = fieldMappings[name];
                field.isReadOnly = true;
                field.commentLong = '';
                field.comment = '';
                field.visible = true;
                updatedFields[name] = field;
            }
        });

        return updatedFields;
    };

    const updateFieldsFromBackend = (fields) => {
        let updatedFields = {};

        updatedFields[TO_RECIPIENT_CATEGORY_TYPE] = fields[TO_RECIPIENT_CATEGORY_TYPE];
        updatedFields[TO_RECIPIENT_SELF] = fields[TO_RECIPIENT_SELF];
        updatedFields[TO_RECIPIENT_OTHER] = fields[TO_RECIPIENT_OTHER];

        return updatedFields;
    };

    const { chooseSelfTitle, chooseSelfButton } = usePageMessages();
    return (
        <SimplePopup text={chooseSelfTitle} popupRef={popupRef}>
            <PopupButton
                iconName="arrow-forward"
                text={chooseSelfButton}
                onClick={() => {
                    let redirectUrlWithParams = window.location.pathname + `?type=${RECIPIENT_TYPE_SELF}&${KEEP_AMOUNT}=true`;
                    props.setSearchParams({ type: RECIPIENT_TYPE_SELF });
                    if (repeatId) {
                        redirectUrlWithParams += `&repeatId=${repeatId}`;
                    }
                    if (recipientId) {
                        redirectUrlWithParams += `&recipientId=${recipientId}`;
                    }
                    popupRef.current?.close();
                    props.toggleSpinner(true);

                    if (!fields[TO_RECIPIENT_OTHER]?.visible) {
                        props.updateFields(SEND_FORM_NAME, getNewFieldsForMyself());
                    }

                    apiFetchData(redirectUrlWithParams, fields)
                        .then((json) => {
                            if (json?.redirectTo) {
                                window.location.href = json.redirectTo;
                            }

                            if (json.messages) {
                                props.updatePageMessages(json.messages);
                            }

                            if (fields[TO_RECIPIENT_OTHER]?.visible) {
                                const form = json.forms[SEND_FORM_NAME];
                                props.updateFields(SEND_FORM_NAME, updateFieldsFromBackend(form.fields));
                            }
                        })
                        .finally(() => {
                            props.toggleSpinner(false);
                            changeBrowserUrlWithOutReload(redirectUrlWithParams);
                        });
                }}
            />
        </SimplePopup>
    );
};

ChangeRecipientTypeToMyself.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

export default connect(null, { toggleSpinner, updatePageMessages, updateFields })(ChangeRecipientTypeToMyself);
